import React from 'react'
import { Stack, Typography } from '@mui/material'
import { CreditCardRounded } from '@mui/icons-material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ChargingSessionModelV1 } from '../models/charging-session.model'

interface AuthenticationCellProps {
  authType: ChargingSessionModelV1['authentication']['type']
  rfid?: string | null
}

export const AuthenticationInfoV1: React.VFC<AuthenticationCellProps> = ({ authType, rfid }) => {
  const { t } = useCustomTranslation()
  const authTypeLabel = t(`emobility.chargingSession.authType.${authType}`)

  if (authType === 'NONE') {
    return (
      <Typography variant="body2" color="text.disabled">
        {t('emobility.chargingSession.noAuthentication')}
      </Typography>
    )
  }

  if (authType === 'RFID' || authType === 'rfid') {
    return (
      <Stack direction="row" spacing={2}>
        <CreditCardRounded />

        <Typography variant="body2" alignSelf="center">
          {`RFID: ${rfid}`}
        </Typography>
      </Stack>
    )
  }

  return (
    <Typography variant="body2" alignSelf="center">
      {authTypeLabel}
    </Typography>
  )
}
